
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import AIRecommendationFlow from "./AIRecommendationFlow";
import ResourceRecommendations from "./ResourceRecommendations";
import TaskAllocationAnalysis from "./TaskAllocationAnalysis";
import ProjectCostAnalysis from "./ProjectCostAnalysis";
import BudgetAnalysisDisplay from "./components/BudgetAnalysisDisplay";
import { formatOpenAIResponse } from "./utils/responseFormatter";

interface AnalysisContentProps {
  activeAnalysis: string;
  recommendation: any;
  resources: any[];
  selectedProject: any;
  getTeamStatsFromRecommendation: () => any;
}

const AnalysisContent = ({ 
  activeAnalysis, 
  recommendation, 
  resources, 
  selectedProject, 
  getTeamStatsFromRecommendation 
}: AnalysisContentProps) => {
  const renderContent = () => {
    switch (activeAnalysis) {
      case "overview":
        return (
          <Card className="bg-secondary/50 backdrop-blur-lg border-2 border-primary">
            <CardHeader className="py-3">
              <CardTitle className="text-white flex items-center gap-2">
                <Sparkles className="h-5 w-5 text-primary" />
                AI Analysis Overview
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <div className="bg-secondary/50 p-3 rounded-lg border border-primary/20">
                {formatOpenAIResponse(recommendation.reasoning, recommendation.rawAnalysis, getTeamStatsFromRecommendation)}
              </div>
            </CardContent>
          </Card>
        );
      case "structure":
        return <AIRecommendationFlow recommendation={recommendation} />;
      case "resources":
        return (
          <ResourceRecommendations
            recommendedResources={recommendation.recommendedResources}
            allResources={resources}
          />
        );
      case "allocation":
        return (
          <TaskAllocationAnalysis
            taskAllocations={recommendation.taskAllocations}
            project={selectedProject}
          />
        );
      case "budget":
        return (
          <BudgetAnalysisDisplay 
            budgetAnalysis={recommendation.budgetAnalysis}
            selectedProject={selectedProject}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex-grow overflow-auto">
      {renderContent()}
    </div>
  );
};

export default AnalysisContent;
